import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { UtilService } from 'src/app/shared/architecture/services/util.service';
import { CriticalRequestService } from 'src/app/shared/services/core/critical-request.service';
import { ChangeDetectorRef } from '@angular/core';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { IPaginatedFilters } from 'src/app/shared/architecture/envelopes';

@Component({
  selector: 'app-solic-critica',
  imports: [TegelModule, CommonModule, NgxPaginationModule],
  templateUrl: './solic-critica.component.html',
  styleUrl: './solic-critica.component.scss'
})
export class SolicCriticaComponent implements OnInit {
  criticalRequests: any[];
  page = 1;
  searchText = '';
  total!: number;
  reverse: boolean = false;
  order = "ID";

  constructor(
    private criticalRequestService: CriticalRequestService,
    private utilService: UtilService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {
    this.criticalRequests = [];
  }

  ngOnInit() {
    this.getAllCriticalRequests(1);
  }

  getAllCriticalRequests(page: number){
    this.criticalRequestService.get(page, this.order, this.utilService.getOrderType(this.reverse), this.searchText).subscribe((result) => {
      if (result){
        this.criticalRequests = result.page;
        this.page = result.currentPage;
        this.total - result.totalRecords;
        this.cdr.detectChanges();
        console.log(this.criticalRequests);
        console.log(this.total);
      }
    });
  }

  confirmDelete(id: number){
    Swal.fire({
      title: 'Excluir',
      text: `Deseja excluir a solicitação ${id}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
    }).then((result) => {

      if (result.isConfirmed) {
        this.deleteById(id);

        Swal.fire({
          title: 'Excluído!',
          text: 'A solicitação foi removida com sucesso.',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          this.getAllCriticalRequests(1);
          this.router.navigate(['../Consultas/SolicitacaoCritica']);
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.router.navigate(['../Consultas/SolicitacaoCritica']);
      }
    });
  }

  deleteById(id: number){
    this.criticalRequestService.delete(id).subscribe((result) => {
      if (result && !result.hasErrors) {
        let index = 0;
        do {
          index = this.criticalRequests.findIndex(c => c.id === id);
          if (index > -1) {
            this.criticalRequests.splice(index, 1);
          }
        } while (index != -1); 
      }
    })
  }

}
